import { Link, useNavigate } from 'react-router-dom';
import './LoginV2.css';
import NavbarV2 from '../../components/navbarV2/NavbarV2';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from 'react';

const LoginV2 = () => {
    const navigate = useNavigate();
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [statusMessage, setStatusMessage] = useState('');

    const handleForgotPassword = () => {
        setShowForgotPassword(true);
        setStatusMessage('');
    };

    const handleSendResetLink = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API}/api/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (response.ok) {
                setStatusMessage('A password reset link has been sent to your email.');
            } else {
                setStatusMessage('Something went wrong. Please try again.');
            }
        } catch (error) {
            console.error('Error:', error);
            setStatusMessage('An error occurred. Please try again.');
        }
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();

        fetch(`${process.env.REACT_APP_API}/api/login`, {
            method: 'POST',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({
                email: document.getElementById('email').value,
                password: document.getElementById('password').value,
            }),
        }).then((response) => {
            if (response.status === 200) {
                response.json().then((data) => localStorage.setItem('admin', data ? data : false));
                localStorage.setItem('account', document.getElementById('email').value);
                toast.success('Logged in successfully!');
                navigate('/');
            } else if (response.status === 401) {
                toast.error('Wrong password!');
            } else if (response.status === 404) {
                toast.error('Account not found.');
            }
        });
    };

    return (
        <div className="v2-page loginv2">
            <NavbarV2 />

            <div className="v2-container v2-container--narrow loginv2-inner">
                {!showForgotPassword && (
                    <div className="v2-card loginv2-card">
                        <h1 className="v2-h1 loginv2-title">Log in</h1>
                        <p className="v2-muted loginv2-lead">Sign in with your Sicily account email.</p>

                        <form onSubmit={handleLoginSubmit}>
                            <div className="v2-field">
                                <label htmlFor="email">Email</label>
                                <input type="email" name="email" id="email" autoComplete="email" required />
                            </div>
                            <div className="v2-field">
                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    autoComplete="current-password"
                                    required
                                />
                            </div>
                            <div className="v2-actions loginv2-actions">
                                <button type="submit" className="v2-btn v2-btn--primary">
                                    Log in
                                </button>
                            </div>
                        </form>

                        <div className="loginv2-footer">
                            <button type="button" className="loginv2-link-btn" onClick={handleForgotPassword}>
                                Forgot password?
                            </button>
                            <p className="v2-muted loginv2-register">
                                New here?{' '}
                                <Link to="/register" className="loginv2-inline-link">
                                    Create an account
                                </Link>
                            </p>
                        </div>
                    </div>
                )}

                {showForgotPassword && (
                    <div className="v2-card loginv2-card">
                        <h1 className="v2-h1 loginv2-title">Reset password</h1>
                        <p className="v2-muted loginv2-lead">We&apos;ll email you a link to choose a new password.</p>

                        {!statusMessage && (
                            <form onSubmit={handleSendResetLink}>
                                <div className="v2-field">
                                    <label htmlFor="forgot-email">Email</label>
                                    <input
                                        type="email"
                                        id="forgot-email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        autoComplete="email"
                                        required
                                    />
                                </div>
                                <div className="v2-actions loginv2-actions">
                                    <button type="submit" className="v2-btn v2-btn--primary">
                                        Send reset link
                                    </button>
                                    <button
                                        type="button"
                                        className="v2-btn v2-btn--outline"
                                        onClick={() => {
                                            setShowForgotPassword(false);
                                            setStatusMessage('');
                                            setEmail('');
                                        }}
                                    >
                                        Back to log in
                                    </button>
                                </div>
                            </form>
                        )}

                        {statusMessage && (
                            <>
                                <p className="loginv2-status">{statusMessage}</p>
                                <div className="v2-actions loginv2-actions">
                                    <button
                                        type="button"
                                        className="v2-btn v2-btn--outline"
                                        onClick={() => {
                                            setShowForgotPassword(false);
                                            setStatusMessage('');
                                            setEmail('');
                                        }}
                                    >
                                        Back to log in
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoginV2;
